import { merge } from 'lodash';
import API from './API';

type useFetchTypes = {
  method: 'get' | 'post' | 'put' | 'patch' | 'delete' | 'options';
  url: string;
  data?: string;
  config?: any;
};

const fetchData = async ({ method, url, data, config }: useFetchTypes) => {
  let response: any = [];
  let hasError: { error: boolean; body: string } = { error: false, body: '' };
  let isLoading: boolean = false;

  const newConfig: any = merge(
    {
      headers: {
        'Content-Type': 'application/json',
      },
    },
    config
  );

  const fetch = async () => {
    isLoading = true;
    await API({
      url,
      method,
      data,
      ...newConfig,
    })
      .then((resp: { data: any; status: number }): any => {
        response = resp.data;
      })
      .finally(() => {
        isLoading = false;
      })
      .catch((error) => {
        let errorInfo: string;
        if (error.response) {
          if (error.response.status) {
            errorInfo = error.response.data.message[0].messages[0].message;
          } else {
            errorInfo = `${error.response.status}: ${error.response.data}`;
          }
        } else if (error.request) {
          errorInfo = error.request;
        } else {
          errorInfo = error.message;
        }
        hasError = { ...hasError, error: true, body: errorInfo };
      });
  };
  await fetch();
  return { response, hasError, isLoading };
};

export default fetchData;
